import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import CarbonCreditCard from '../../carbonCreditCard/carbonCreditCard';

export default function NftTable(props) {
  return (
    <Grid container spacing={0} align="center">
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Typography paragraph variant="body1">
          {props.title}
        </Typography>
        <Grid container spacing={2} align="center" style={{ padding: 20 }}>
          {props.nfts?.map((nft) => (
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CarbonCreditCard
                id={nft.id}
                name={nft.name}
                ipfs={nft.ipfs}
                ipfsHash={nft.truncateHashIPFS}
                blockchain={nft.blockchain}
                blockchainHash={nft.truncateHashBlockchain}
                is_sbt={nft.is_sbt}
                imageCarbonCredit={nft.image_project}
                name_project={nft.name_project}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
